// extracted by mini-css-extract-plugin
export default {"payPeriod-header":"Header_payPeriod-header__JnQn2","payPeriod-header-item":"Header_payPeriod-header-item__NsNIR"};